//create a react functional component in typescript
import { useEffect, useState, type FC } from "react";

import ContactListItem from "./contactlistitem";
import { BlockingSpinner } from "./ui";

interface groupListProps {
  refresh: () => void;
  toggleManageContactListsModal: () => void;
}

const ContactLists: FC<groupListProps> = ({
  refresh,
  toggleManageContactListsModal,
}) => {
  const [contactLists, setContactLists] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  const getLists = async () => {
    setLoading(true);

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const storedJWT = localStorage.getItem("jwt");

    user.email &&
      (await fetch(process.env.REACT_APP_API_URL + "/get-contact-lists.php", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + storedJWT,
        },
        body: JSON.stringify({
          email: user.email,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setContactLists(data);
          setLoading(false);
        })
        .catch(() => {
          // Handle network or server errors
          console.error();
          setLoading(false);
        }));
  };

  //create the function to create a folder
  useEffect(() => {
    getLists();
  }, [refresh]);

  return (
    <div className="inline-block w-full p-6 pt-6 pr-6">
      <div className="flex justify-between mb-3">
        <h1 className="mb-4 text-xl text-default">Manage contact lists</h1>
        <svg
          onClick={toggleManageContactListsModal}
          className="cursor-pointer"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.40918 1.43213L13.9192 13.9421"
            stroke="rgb(var(--color-text))"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9189 1.43213L1.40895 13.9421"
            stroke="rgb(var(--color-text))"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {loading ? (
        <BlockingSpinner />
      ) : (
        <div className="max-h-[60vh] max-w-full relative overflow-x-scroll border-b border-slate-100 pb-5">
          <div className="grid grid-cols-2">
            <div>
              <p className="px-3 mt-1 mb-3 text-xs leading-5 text-gray-500">
                Name
              </p>
            </div>
          </div>
          {Array.isArray(contactLists) &&
            contactLists.map((list) => {
              return <ContactListItem key={list.ID} list={list} />;
            })}
        </div>
      )}
    </div>
  );
};
export default ContactLists;
